import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

function readSavedTheme() {
  if (typeof window === "undefined") return "dark";
  try {
    return window.localStorage.getItem("kd9-theme") === "light" ? "light" : "dark";
  } catch (_) {
    // Restricted browser storage must never make the KD9 application render blank.
    return "dark";
  }
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(readSavedTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    try {
      window.localStorage.setItem("kd9-theme", theme);
    } catch (_) {
      // Theme remains usable when the browser disables local storage.
    }
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
